import * as React from "react";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { useStoreDollHouseMap } from "../store";
import { shallow } from "zustand/shallow";
// import { __zoomIn, __zoomOut } from "../assets/model/Isometric_View_BAKED-v2";
import { isDesktop, isMobile } from "react-device-detect";
import ss from "../assets/images/Group 4 1.svg";

const ZoomItem = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  ...theme.typography.body2,
  position: "absolute",
  zIndex: 3,
  bottom: "10px",
  right: "10px",
  padding: 0,
  width: "auto",
  height: "auto",
  border: "none",
  borderRadius: 10,
  color: "#ffffff",
  boxShadow: "none",
}));

const ZoomIcons = {
  background: "#000000 0% 0% no-repeat padding-box",
  margin: "2px",
  borderRadius: "6px",
  width: "37px",
  height: "37px",
  padding: "5px",
  "&:hover": {
    background: "#000000 0% 0% no-repeat padding-box",
  },
};

let ZoomComponent = ({ index }) => {
  const [showFeedbackBtn, setShowFeedbackBtn] = React.useState(true);
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      panComponentObj: state.panComponentObj,
      updateFeedbackVisibility: state.updateFeedbackVisibility,
      feedbackSubmittedStatus: state.feedbackSubmittedStatus,
    }),
    shallow
  );

  React.useEffect(() => {
    if (dollhouseStore.feedbackSubmittedStatus) {
      setShowFeedbackBtn(false);
    }
  }, [dollhouseStore.feedbackSubmittedStatus]);

  const zoomIn = () => {
    // if (isDesktop) {
    if (dollhouseStore.panComponentObj) {
      const { zoomIn } = dollhouseStore.panComponentObj.current;
      zoomIn(0.5);
    }

    // }
    // if (isMobile) {
    //   if (index) {
    //     if (dollhouseStore.panComponentObj) {
    //       const { zoomIn } = dollhouseStore.panComponentObj.current;
    //       zoomIn(0.5);
    //     }
    //   } else {
    //     __zoomIn();
    //   }
    // }
  };

  const zoomOut = () => {
    // if (isDesktop) {
    if (dollhouseStore.panComponentObj) {
      const { zoomOut } = dollhouseStore.panComponentObj.current;
      zoomOut(0.5);
    }
    // }
    // if (isMobile) {
    //   if (index) {
    //     if (dollhouseStore.panComponentObj) {
    //       const { zoomOut } = dollhouseStore.panComponentObj.current;
    //       zoomOut(0.5);
    //     }
    //   } else {
    //     __zoomOut();
    //   }
    // }
  };

  const feedback = () => {
    dollhouseStore.updateFeedbackVisibility(true);
  };

  return (
    <>
      <ZoomItem>
        {showFeedbackBtn && (
          <IconButton aria-label="feedback" sx={ZoomIcons} onClick={feedback}>
            <img src={ss} />
          </IconButton>
        )}

        <IconButton aria-label="zoomOut" sx={ZoomIcons} onClick={zoomOut}>
          <ZoomOutIcon
            sx={{
              color: "#ffffff",
              borderRadius: "6px",
            }}
          />
        </IconButton>
        <IconButton aria-label="zoomIn" sx={ZoomIcons} onClick={zoomIn}>
          <ZoomInIcon
            sx={{
              color: "#ffffff",
              borderRadius: "6px",
            }}
          />
        </IconButton>
      </ZoomItem>
    </>
  );
};

function __setScale(value) {}
function ZoomButtonComponent(e) {
  return <ZoomComponent index={e.index} />;
}
export { ZoomButtonComponent, __setScale };
